const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "SECTIONS_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "SECTIONS_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "SECTIONS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
